export default function mapCenterHandler(map, location, padding, zoom) {
  map.setCenter(
    {
      lat: location.latitude,
      lng: location.longitude,
    },
    padding,
  );

  map.setZoom(zoom);
}
